<script setup lang="ts">
  import { reactive, watch } from 'vue'

  const props = defineProps({
    password: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  })

  const validationCriteria = reactive({
    uppercase: false,
    lowercase: false,
    hasNumber: false,
    minLength: false,
  })

  const emit = defineEmits(['update:modelValue'])

  watch(
    () => props.password,
    (current) => {
      validationCriteria.lowercase = false
      validationCriteria.uppercase = false
      validationCriteria.hasNumber = false
      validationCriteria.minLength = false
      emit('update:modelValue', false)

      const lowerCaseLetters = /[a-z]/g
      if (current.match(lowerCaseLetters)) {
        validationCriteria.lowercase = true
      }

      const upperCaseLetters = /[A-Z]/g
      if (current.match(upperCaseLetters)) {
        validationCriteria.uppercase = true
      }

      const numbers = /[0-9]/g
      if (current.match(numbers)) {
        validationCriteria.hasNumber = true
      }

      if (current.length >= 8) {
        validationCriteria.minLength = true
      }

      if (
        validationCriteria.uppercase &&
        validationCriteria.lowercase &&
        validationCriteria.hasNumber &&
        validationCriteria.minLength
      ) {
        emit('update:modelValue', true)
      }
    },
  )
</script>

<template>
  <div class="d-flex justify-content-end gap-2 mt-2">
    <span
      class="circle"
      :class="[
        validationCriteria.minLength ? 'bg--success' : 'bg--grayscale-light',
      ]"
    >
      +8
    </span>
    <span
      class="circle"
      :class="[
        validationCriteria.uppercase ? 'bg--success' : 'bg--grayscale-light',
      ]"
    >
      A
    </span>
    <span
      class="circle"
      :class="[
        validationCriteria.lowercase ? 'bg--success' : 'bg--grayscale-light',
      ]"
    >
      a
    </span>
    <span
      class="circle"
      :class="[
        validationCriteria.hasNumber ? 'bg--success' : 'bg--grayscale-light',
      ]"
    >
      123
    </span>
  </div>
</template>

<style scoped>
  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
</style>
